export const trackingLinkByMethod: Partial<Record<string, string>> = {
  ['colis éco']:
    'https://www.laposte.fr/outils/suivre-vos-envois?code=%trackingNumber%',
  ['colissimo']:
    'https://www.laposte.fr/outils/suivre-vos-envois?code=%trackingNumber%',
  ['Mondial Relay']:
    'https://www.mondialrelay.com/public/permanent/tracking.aspx?ens=F3AFIBEL42&exp=%trackingNumber%&language=FR',
};

export const SUPPORTED_TRACKING_METHODS = Object.keys(trackingLinkByMethod);

export function hasTrackingLink(deliveryMethod: string): boolean {
  return SUPPORTED_TRACKING_METHODS.includes(deliveryMethod);
}
